import { z } from "zod";
import { patchOf } from "../common/patch.js";
import { timestampSchema, uuidSchema } from "../common/primitives.js";
/**
 * Fiyat grupları (Prompt 16, ADR 0016 §14): toplu fiyat değişikliğinde istasyon SEÇİM kısayolu. Fiyatın kaynağı
 * istasyon × ürün (`station_prices`) kalır; grup seçilince değişiklik grubun istasyonlarına açılır. Bir istasyon
 * en çok BİR fiyat grubundadır. Şirket düzeyidir (grup yalnızca kendi şirketinin istasyonlarını içerir).
 */
export const priceGroupStationSchema = z.object({
    stationId: uuidSchema,
    stationCode: z.string(),
    stationName: z.string(),
});
export const priceGroupSchema = z.object({
    id: uuidSchema,
    companyId: uuidSchema,
    code: z.string(),
    name: z.string(),
    isActive: z.boolean(),
    stations: z.array(priceGroupStationSchema),
    version: z.number().int(),
    createdAt: timestampSchema,
});
export const priceGroupListSchema = z.object({ items: z.array(priceGroupSchema) });
export const listPriceGroupsQuerySchema = z.object({
    companyId: uuidSchema.optional().describe("Verilmezse görülebilen tüm şirketler"),
    isActive: z.enum(["true", "false"]).optional(),
});
const stationIdsSchema = z
    .array(uuidSchema)
    .max(500)
    .refine((ids) => new Set(ids).size === ids.length, "Aynı istasyon iki kez seçilemez");
export const createPriceGroupSchema = z.object({
    companyId: uuidSchema,
    code: z
        .string()
        .trim()
        .toUpperCase()
        .regex(/^[A-Z0-9][A-Z0-9_-]{1,29}$/, "Kod 2–30 karakter; büyük harf, rakam, - ve _ içerebilir"),
    name: z.string().trim().min(1, "Grup adı zorunludur").max(120),
    stationIds: stationIdsSchema.default([]).describe("Üye istasyonlar (bir istasyon en çok bir grupta)"),
});
export const updatePriceGroupSchema = patchOf(createPriceGroupSchema.pick({ name: true })).extend({
    isActive: z.boolean().optional(),
    version: z.number().int().positive(),
});
/** Üye kümesi TAMAMEN değiştirilir (PUT). */
export const savePriceGroupStationsSchema = z.object({
    stationIds: stationIdsSchema,
    version: z.number().int().positive(),
});
//# sourceMappingURL=price-groups.js.map